import { useFormContext } from 'react-hook-form'
import styles from 'styles/add/SpecSummary.module.css'

const SpecSummary = () => {
    const { getValues } = useFormContext()
    const values = getValues(['marka', 'model'])
    const [marka = '', model = ''] = values || []

    return (
        <div className={styles.wrap}>
            <h2>{`${marka} ${model}`.trim()}</h2>
        </div>
    )
}

export default SpecSummary